import { post } from '../Services/http';
import { catchError } from './Error.action';
import LocalStorageService from '../Services/localstorage';

export const FAVORITE_PRODUCT_RECEIVE = 'FAVORITE_PRODUCT_RECEIVE';
export const FAVORITE_PRODUCT_ERROR = 'FAVORITE_PRODUCT_ERROR';

export const load = () => (dispatch, getState) => {
    var articleNumbers = LocalStorageService.getArray("favoriteProducts");

    return post("/api/favorites/getFavorites", { articleNumbers })
        .then(response => response.json())
        .then(favoriteProducts => dispatch(receive(favoriteProducts)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}

export const receive = favoriteProducts => ({
    type: FAVORITE_PRODUCT_RECEIVE,
    payload: favoriteProducts,
})

export const loadError = error => ({
    type: FAVORITE_PRODUCT_ERROR,
    payload: {
        error,
    }
})
